import $ from 'jquery';
import lazyLoad from './lazyLoad';
import responsiveBg from './responsiveBg';

export default () => {
    const slider = $('.js-hero-slider');

    slider.slick({
        slidesToShow: 1,
        mobileFirst: true,
        arrows: false,
        dots: true,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 5000,
        appendDots: $('.HeroSpecial__dots div'),
    });

    $(window).on('load', function () {
        lazyLoad('.js-hero-slider .lazy');

        responsiveBg('.js-hero-slider .js-responsive-bg');
    });
};



// WEBPACK FOOTER //
// ../src/scripts/modules/hero-special.js